import * as uuid from 'uuid';

export const getDeviceName = () => {
  let deviceName = localStorage.getItem('DEVICE_ID');

  if (!deviceName) {
    deviceName = uuid.v4();
    localStorage.setItem('DEVICE_ID', deviceName);
  }

  return deviceName;
};
